<script setup lang="ts">
const emit = defineEmits<{
    close: [args?: { silentClose?: boolean }];
}>();
</script>
<template>
    <mr-modal
        title="شرایط و قوانین رزرو خودکار"
        width="500px"
        mobile-page
        @close="emit('close')"
    >
        <template #default>
            <div class="conditions">
                <mr-typography size="small" weight="700">
                    قوانین رزرو خودکار
                </mr-typography>
                <mr-typography size="small">
                    کاربر گرامی؛ درصورتی که اولین بار است که از سرویس رزرو
                    خودکار استفاده می‌کنید، به دلیل تفاوت در ساز و کار این نوع
                    رزرو با دیگر فرآیندهای رزرو، لازم است شرایط و مقررات سرویس
                    را مطالعه و مورد توجه قرار دهید. مبلغ پرداختی به اعتبار
                    کاربری شما افزوده می‌شود. مبلغی که در انتها برای این رزرو
                    پرداخت می‌کنید، سپرده شما نزد ماست و شما می‌توانید هر زمانی
                    که مایل باشید کل و یا بخشی از آن را به حساب یا کارت بانکی
                    استرداد کنید. استرداد اعتبار در اکثر موارد به‌صورت آنی بوده
                    و در موارد خاص حداکثر تا سه روز کاری زمان خواهد برد. تنها
                    زمانی که بلیط به‌صورت قطعی صادر شود این مبلغ از اعتبار
                    کاربری شما کسر می‌شود. توجه داشته باشید، درصورتی‌که هنگام
                    موجود شدن ظرفیت اعتبار شما کافی نباشد، رزرو شما لغو خواهد
                    شد. به محض موجود شدن ظرفیت، فرآیند خرید به صورت خودکار انجام
                    می‌شود. پس از انتخاب سفرها و ساعت آن (پرواز، اتوبوس و...)،
                    سیستم رزرو خودکار مِستربلیط، به‌صورت مداوم اقدام به بررسی
                    ظرفیت سفرها خواهد کرد و در صورت آزاد شدن ظرفیت مورد نظر،
                    اقدام به خریداری خودکار بلیط می‌کند. در صورت انتخاب چندین
                    سفر، تنها یکی از آنان (هر سفری که موجود شود) برای شما
                    خریداری می‌گردد. همچنین کل تعداد بلیط درخواستی شما روی یک
                    سفر (زمان و سرویس مشخص) صادر می‌شود و امکان صدور روی چند سفر
                    وجود ندارد. در ضمن، امکان ساخت چند رزرو خودکار روی یک سفر
                    وجود خواهد داشت که هر کدام به‌صورت مجزا عمل کرده و صادر
                    می‌شوند. قبل از صدور قطعی، می‌توانید بدون جریمه انصراف دهید.
                    تا زمانی که بلیط واقعاً توسط سیستم صادر نشده است، می‌توانید
                    با مراجعه به صفحه رزرو خودکار در پنل کاربری، (قابل دسترسی در
                    منوی مدیریت کاربری) رزرو خودکار خود را لغو کنید. پس از این
                    کار دیگر بلیط برایتان صادر نمی‌شود و می‌توانید مبلغ پرداختی
                    را از اعتبار کاربری به حساب یا کارت بانکی استرداد کنید. توجه
                    داشته باشید اگر از طریق دیگر قبل از قطعی شدن رزرو موفق به
                    تهیه بلیط شدید، باید این رزرو را لغو کنید، وگرنه دو بلیط
                    خواهید داشت که باید یکی را با پرداخت جریمه کنسل کنید! اگر
                    رزرو قطعی شد، کنسلی و انصراف از آن مشمول جریمه است. تا قبل
                    از این‌که رزرو برای شما نهایی شود شما می‌توانید هر زمانی که
                    مایل باشید بدون پرداخت هزینه‌ای درخواست رزرو خودکار خود را
                    لغو کنید. اما به محض صدور بلیط، کنسلی آن مطابق قوانین
                    تأمین‌کننده مربوطه مشمول جریمه خواهد بود. میزان جریمه بنا به
                    تأمین‌کننده و زمان باقی‌مانده تا سفر متغیر خواهد بود و حتی
                    ممکن است غیرقابل استرداد باشد. توضیح بیشتر این‌که کنسلی بلیط
                    صادرشده در اکثر موارد از سمت تأمین‌کننده (ایرلاین،
                    چارترکننده و تعاونی) مشمول جریمه است و جریمه مذکور از سمت
                    مِستربلیط اعمال نمی‌شود، لذا (بر خلاف خواسته قلبی ما!) کنسلی
                    بدون جریمه آن از عهده و اختیار مِستربلیط خارج خواهد بود. سه
                    ساعت قبل از سفر، جستجو پایان می‌یابد. رزرو خودکار ظرفیت سفر
                    را تا سه ساعت قبل از آن رهگیری می‌کند و درصورت موجود شدن،
                    بلیط برای شما خریداری می‌شود. بعد از این زمان امکان موجود
                    شدن ظرفیت برای این سفر به‌صورت آنلاین وجود ندارد. اگر سفر
                    خیلی ضروری دارید می‌توانید بعد از این زمان شانس را خود برای
                    خرید بلیط در فرودگاه یا ترمینال نیز امتحان کنید. مبلغ بلیط
                    صادر شده ممکن است کمتر باشد. مبلغ بلیط در لحظه ساخت رزرو
                    مشخص نیست و ما سقف مبلغ این مسیر را از شما دریافت می‌کنیم
                    (براساس قوانین سازمان‌های مربوطه، مبلغ بلیط از سقف مشخصی
                    نمی‌تواند بیشتر باشد). اگر بلیط با قیمت کمتری صادر شد،
                    باقی‌مانده پول در اعتبار شما موجود خواهد بود و می‌توانید آن
                    را استرداد کنید. مبلغ خدمات رزرو جدای از مبلغ بلیط دریافت
                    می‌شود. بنا به سطح کاربری و سابقه خریدهای شما، ممکن است
                    مبلغی به‌عنوان هزینه خدمات رزرو خودکار از شما دریافت شود.
                    این مبلغ در صورت‌حساب به شما نمایش داده می‌شود. اگر بلیطی
                    برای شما صادر نشد، هیچ هزینه‌ای (چه هزینه بلیط و چه هزینه
                    خدمات) از شما دریافت نمی‌شود، ولی درصورت صدور بلیط، مبلغ
                    مذکور به‌عنوان هزینه استفاده از سرویس رزرو خودکار از شما
                    دریافت می‌شود و این مبلغ جدای از مبلغ بلیط شما خواهد بود.
                    درصورتی که رزرو خودکار با موفقیت انجام و سفر به هر دلیل کنسل
                    شود، هزینه خدمات رزرو خودکار برای مسافر استرداد نخواهد شد.
                    صدور قطعی و یا تغییر در وضعیت رزرو خودکار، به صورت پیامک،
                    ایمیل و یا تماس خودکار اطلاع رسانی می‌شود. البته ممکن است
                    بخواهید از طریق دیگر نیز شانس خود را برای خرید بلیط امتحان
                    کنید، لذا پیش از نهایی کردن خرید از مسیرهای دیگر، حتماً
                    وضعیت رزرو خود را بررسی کنید، چون ممکن است به‌دلیل اختلالات
                    مخابراتی پیامک صدور دیرتر برایتان ارسال شود.
                </mr-typography>
            </div>
        </template>

        <template #footer>
            <mr-button full-width @click="emit('close')"> بازگشت </mr-button>
        </template>
    </mr-modal>
</template>
